import React, { useMemo, useState } from 'react'
import {
  Form,
  Button,
  Title
} from 'components/atoms'
import { Formik, Field } from 'formik';
import { FieldCustom, ModalConfirm } from 'components/molecules';
import PropTypes from 'prop-types'
import * as Yup from 'yup';
import styled from 'styled-components/macro';
import { slugRegex } from 'services/constants';
import { generateSubwebPath } from 'services/generators';
import { useMutation } from 'react-query'
import { putSlug } from 'services/requests'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useToggle } from 'hooks'
import { useEditorContext, actions } from 'context/EditorContext';

const PageSchema = Yup.object().shape({
  slug: Yup.string().matches(slugRegex, 'Apenas pode ter letras minúsculas, palavras separadas por -, e não pode conter a palavra noticias ou news').required('Campo obrigatório'),
});

const PageUpdateSlugForm = ({
  initialSlug,
  subweb,
  lang,
  pageId,
}) => {
  const [newSlug, setNewSlug] = useState(initialSlug)
  const [isOpenConfirmation, toggle] = useToggle(false)
  const [, dispatch] = useEditorContext();

  const [updateSlug, { isLoading }] = useMutation(putSlug, {
    onSuccess: () => {
      dispatch({
        type: actions.PAGE_SLUG_UPDATE,
        data: newSlug,
      })
      toast.success(
        <Toast
          type="success"
          title="Endereço amigável editado"
          description="O novo endereço foi gravado com sucesso."
        />
      );
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a editar endereço amigável"
          description={err.message}
        />
      );
    }
  })
  const subwebUrl = useMemo(() => generateSubwebPath(
    { subweb, lang, withHost: true }
  ), [subweb, lang])

  const initialValues = useMemo(() => ({
    slug: initialSlug
  }), [initialSlug])

  const handleUpdateSlug = ({ slug }) => {
    setNewSlug(slug)
    updateSlug({
      slug, subweb, language: lang, pageId
    })
  }

  const handleConfirm = async (hasConfirmed, handleSubmit) => {
    if (hasConfirmed) {
      handleSubmit()
    }
    toggle()
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={PageSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleUpdateSlug(values);
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ values, handleSubmit }) => (
          <>
            <ModalConfirm
              isOpen={isOpenConfirmation}
              toggle={toggle}
              onChange={(hasConfirmed) => handleConfirm(hasConfirmed, handleSubmit)}
              title="Alteração do URL"
              message="Ao alterar o endereço da página ela deixará de ficar acessível com o endereço anterior. Se partilhou o URL da página noutros locais da web, ele deixará de ser válido. Tem a certeza que pretende continuar?"
              textConfirm="Sim"
              textDiscard="Cancelar"
            />
            <Title as="h3">Endereço amigável</Title>
            <Form>
              <FieldWithAction>
                <Field
                  name="slug"
                  placeholder={`/page/${pageId}`}
                  component={FieldCustom}
                  modifiers={['stretch']}
                  info={subwebUrl + values.slug}
                />
              </FieldWithAction>
              <Actions>
                <Button
                  onClick={values.slug === initialSlug ? () => {} : toggle}
                  loading={isLoading}
                  modifiers={[
                    'dark', 'small', 'smaller',
                    values.slug === initialSlug ? 'disabled' : '',
                  ]}
                >
              Gravar endereço
                </Button>
              </Actions>
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

const Actions = styled.div`
  display: flex;
`;

const FieldWithAction = styled.div`
  display: inline-flex;
`

FieldWithAction.Action = styled.div`
  margin-top: 2rem;
  padding-left: ${props => props.theme.spacing.xs};
`

PageUpdateSlugForm.propTypes = {
  subweb: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  initialSlug: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
}

export default PageUpdateSlugForm
